// CalculatorDashboard.styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors, Cards, FontWeight } from '../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => {
  const pxToRem = (px: number): string => `${px / 16}rem`;

  return {
    container: {
      ...Cards.CardShadow1,
      padding: pxToRem(40),
      height: '100%',
      position: 'relative',
    },
    title: {
      fontSize: `${pxToRem(28)} !important`,
      color: `${Colors.Blue} !important`,
      fontWeight: `${FontWeight.Bold} !important`,
      marginBottom: `${pxToRem(20)} !important`,
    },
    description: {
      fontSize: `${pxToRem(14)} !important`,
      lineHeight: '24px !important',
      marginBottom: `${pxToRem(36)} !important`,
      '& a': {
        fontSize: pxToRem(14),
        fontWeight: FontWeight.Regular,
      },
    },
    button: {
      maxWidth: 240,
    },
  };
});

export default useStyles;
